export enum ListKind {
    Child = 'child',
    Employee = 'employee',
}

export interface ListFromAPI {
    id: string;
    name: string;
    filter: string;
    description: string;
    created: string;
    updated: string;
    private: boolean;
    editable: boolean;
    kind: ListKind;
    bookmarked: false; // Todo:  Bookmarking is not implemented by backend yet
    longName?: string;
    preset?: boolean;
}

export interface ListsResponse {
    presets: ListFromAPI[];
    saved: ListFromAPI[];
}
